var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.loadedPage,attrs:{"id":"app"}},[_c('div',{staticClass:"inner-app"},[_c('transition',{attrs:{"appear":"","mode":"out-in"},on:{"enter":_vm.enter,"leave":_vm.leave}},[_c('router-view')],1),_vm._v(" "),_c('menucomponent')],1),_vm._v(" "),_c('footercomponent')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f6d0e5d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 